export default import.meta.ROLLDOWN_FILE_URL_1fqMnxg1JZ4IzM67Jng1vA